<!-- <div class="container my-3">
    <div class="row font-weight-bolder main-theme-color fnt main-title">
        <div class="col">CART SUMMARY</div>
        <div class="col text-center">GRAND TOTAL</div>
        <div class="col">TIME LEFT</div>
    </div>
</div> -->
<div class="page-title-section row px-3 m-0 pt-5 pb-4 flex-column">
    <div class="main-title secondary-theme-color d-flex justify-content-center text-center">{{'cartSummary' | translate}}</div>
    <div class="mt-3 sub-title main-theme-color d-flex justify-content-center text-center">{{'finalizeYourInterestsHere' | translate}}
    </div>
</div>
<div class="container">
    <div class="p-0 mt-3 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-row justify-content-md-end justify-content-between activity-title">
        <div class="px-2 mx-md-5 d-flex align-items-center">
            <div class="under-header-details-title me-3">{{'grandTotal' | translate}}</div>
            <div class="remove-bs-line-height">$20.00</div>
        </div>
        <div class="px-2 d-flex align-items-center">
            <div class="under-header-details-title me-3">{{'timeLeft' | translate}}</div>
            <div class="remove-bs-line-height">09:00</div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-4 col-md-6 p-3">
            <div class="cartsummary d-flex flex-column">
                <div class="stanleyimg">
                    <img src="https://www.stanleyhotel.com/uploads/9/8/6/9/98696462/stanley-style-043_5_orig.jpg" />
                </div>
                <div class="card-body activity-description-bold">
                    <div class="card-text text-center p-4 ms-5 me-5">
                        <div class="activityname activity-description-bolder">Historic Day Tour</div>
                        <div class="font-weight-bold d-flex flex-row activity-description justify-content-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>place</mat-icon>2A
                            </div>
                            <div class="d-flex align-items-center">
                                <mat-icon>person</mat-icon>2 {{'people' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="text-center cart-summary-date">12/12/2021 - 12/4/2021</div>
                    <div class="p-0">
                        <div class="sessiontotal d-flex justify-content-between py-3">
                            <div>{{'sessionCharges' | translate}} X 2</div>
                            <div>$10.00</div>
                        </div>
                        <div class="py-3 d-flex justify-content-between">
                            <div>{{'total' | translate}}</div>
                            <div>$10.00</div>
                        </div>
                    </div>
                    <div class="mt-5 d-flex justify-content-between activity-description-bold">
                        <div class="d-flex align-items-center cart-buttons">
                            <mat-icon>edit</mat-icon>
                            <div>{{'edit' | translate}}</div>
                        </div>
                        <div class="d-flex align-items-center cart-buttons" (click)="getPopup()">
                            <mat-icon>delete</mat-icon>
                            <div>{{'remove' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 p-3">
            <div class="cartsummary d-flex flex-column">
                <div class="stanleyimg">
                    <img src="https://www.stanleyhotel.com/uploads/9/8/6/9/98696462/stanley-style-043_5_orig.jpg" />
                </div>
                <div class="card-body activity-description-bold">
                    <div class="card-text text-center p-4 ms-5 me-5">
                        <div class="activityname activity-description-bolder">Historic Day Tour</div>
                        <div class="font-weight-bold d-flex flex-row activity-description justify-content-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>place</mat-icon>2A
                            </div>
                            <div class="d-flex align-items-center">
                                <mat-icon>person</mat-icon>2 {{'people' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="text-center cart-summary-date">12/12/2021 - 12/4/2021</div>
                    <div class="p-0">
                        <div class="sessiontotal d-flex justify-content-between py-3">
                            <div>{{'sessionCharges' | translate}} X 2</div>
                            <div>$10.00</div>
                        </div>
                        <div class="py-3 d-flex justify-content-between">
                            <div>{{'total' | translate}}</div>
                            <div>$10.00</div>
                        </div>
                    </div>
                    <div class="mt-5 d-flex justify-content-between activity-description-bold">
                        <div class="d-flex align-items-center cart-buttons">
                            <mat-icon>edit</mat-icon>
                            <div>{{'edit' | translate}}</div>
                        </div>
                        <div class="d-flex align-items-center cart-buttons" (click)="getPopup()">
                            <mat-icon>delete</mat-icon>
                            <div>{{'remove' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 p-3">
            <div class="cartsummary d-flex flex-column">
                <div class="stanleyimg">
                    <img src="https://www.stanleyhotel.com/uploads/9/8/6/9/98696462/stanley-style-043_5_orig.jpg" />
                </div>
                <div class="card-body activity-description-bold">
                    <div class="card-text text-center p-4 ms-5 me-5">
                        <div class="activityname activity-description-bolder">Historic Day Tour</div>
                        <div class="font-weight-bold d-flex flex-row activity-description justify-content-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>place</mat-icon>2A
                            </div>
                            <div class="d-flex align-items-center">
                                <mat-icon>person</mat-icon>2 {{'people' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="text-center cart-summary-date">12/12/2021 - 12/4/2021</div>
                    <div class="p-0">
                        <div class="sessiontotal d-flex justify-content-between py-3">
                            <div>{{'sessionCharges' | translate}} X 2</div>
                            <div>$10.00</div>
                        </div>
                        <div class="py-3 d-flex justify-content-between">
                            <div>{{'total' | translate}}</div>
                            <div>$10.00</div>
                        </div>
                    </div>
                    <div class="mt-5 d-flex justify-content-between activity-description-bold">
                        <div class="d-flex align-items-center cart-buttons">
                            <mat-icon>edit</mat-icon>
                            <div>{{'edit' | translate}}</div>
                        </div>
                        <div class="d-flex align-items-center cart-buttons" (click)="getPopup()">
                            <mat-icon>delete</mat-icon>
                            <div>{{'remove' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 p-3">
            <div class="cartsummary d-flex flex-column">
                <div class="stanleyimg">
                    <img src="https://www.stanleyhotel.com/uploads/9/8/6/9/98696462/stanley-style-043_5_orig.jpg" />
                </div>
                <div class="card-body activity-description-bold">
                    <div class="card-text text-center p-4 ms-5 me-5">
                        <div class="activityname activity-description-bolder">Historic Day Tour</div>
                        <div class="font-weight-bold d-flex flex-row activity-description justify-content-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>place</mat-icon>2A
                            </div>
                            <div class="d-flex align-items-center">
                                <mat-icon>person</mat-icon>2 {{'people' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="text-center cart-summary-date">12/12/2021 - 12/4/2021</div>
                    <div class="p-0">
                        <div class="sessiontotal d-flex justify-content-between py-3">
                            <div>{{'sessionCharges' | translate}} X 2</div>
                            <div>$10.00</div>
                        </div>
                        <div class="py-3 d-flex justify-content-between">
                            <div>{{'total' | translate}}</div>
                            <div>$10.00</div>
                        </div>
                    </div>
                    <div class="mt-5 d-flex justify-content-between activity-description-bold">
                        <div class="d-flex align-items-center cart-buttons">
                            <mat-icon>edit</mat-icon>
                            <div>{{'edit' | translate}}</div>
                        </div>
                        <div class="d-flex align-items-center cart-buttons" (click)="getPopup()">
                            <mat-icon>delete</mat-icon>
                            <div>{{'remove' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 p-3">
            <div class="cartsummary d-flex flex-column">
                <div class="stanleyimg">
                    <img src="https://www.stanleyhotel.com/uploads/9/8/6/9/98696462/stanley-style-043_5_orig.jpg" />
                </div>
                <div class="card-body activity-description-bold">
                    <div class="card-text text-center p-4 ms-5 me-5">
                        <div class="activityname activity-description-bolder">Historic Day Tour</div>
                        <div class="font-weight-bold d-flex flex-row activity-description justify-content-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>place</mat-icon>2A
                            </div>
                            <div class="d-flex align-items-center">
                                <mat-icon>person</mat-icon>2 {{'people' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="text-center cart-summary-date">12/12/2021 - 12/4/2021</div>
                    <div class="p-0">
                        <div class="sessiontotal d-flex justify-content-between py-3">
                            <div>{{'sessionCharges' | translate}} X 2</div>
                            <div>$10.00</div>
                        </div>
                        <div class="py-3 d-flex justify-content-between">
                            <div>{{'total' | translate}}</div>
                            <div>$10.00</div>
                        </div>
                    </div>
                    <div class="mt-5 d-flex justify-content-between activity-description-bold">
                        <div class="d-flex align-items-center cart-buttons">
                            <mat-icon>edit</mat-icon>
                            <div>{{'edit' | translate}}</div>
                        </div>
                        <div class="d-flex align-items-center cart-buttons" (click)="getPopup()">
                            <mat-icon>delete</mat-icon>
                            <div>{{'remove' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 p-3">
            <div class="cartsummary d-flex flex-column">
                <div class="stanleyimg">
                    <img src="https://www.stanleyhotel.com/uploads/9/8/6/9/98696462/stanley-style-043_5_orig.jpg" />
                </div>
                <div class="card-body activity-description-bold">
                    <div class="card-text text-center p-4 ms-5 me-5">
                        <div class="activityname activity-description-bolder">Historic Day Tour</div>
                        <div class="font-weight-bold d-flex flex-row activity-description justify-content-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>place</mat-icon>2A
                            </div>
                            <div class="d-flex align-items-center">
                                <mat-icon>person</mat-icon>2 {{'people' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="text-center cart-summary-date">12/12/2021 - 12/4/2021</div>
                    <div class="p-0">
                        <div class="sessiontotal d-flex justify-content-between py-3">
                            <div>{{'sessionCharges' | translate}} X 2</div>
                            <div>$10.00</div>
                        </div>
                        <div class="py-3 d-flex justify-content-between">
                            <div>{{'total' | translate}}</div>
                            <div>$10.00</div>
                        </div>
                    </div>
                    <div class="mt-5 d-flex justify-content-between activity-description-bold">
                        <div class="d-flex align-items-center cart-buttons">
                            <mat-icon>edit</mat-icon>
                            <div>{{'edit' | translate}}</div>
                        </div>
                        <div class="d-flex align-items-center cart-buttons" (click)="getPopup()">
                            <mat-icon>delete</mat-icon>
                            <div>{{'remove' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 p-3">
            <div class="cartsummary d-flex flex-column">
                <div class="stanleyimg">
                    <img src="https://www.stanleyhotel.com/uploads/9/8/6/9/98696462/stanley-style-043_5_orig.jpg" />
                </div>
                <div class="card-body activity-description-bold">
                    <div class="card-text text-center p-4 ms-5 me-5">
                        <div class="activityname activity-description-bolder">Historic Day Tour</div>
                        <div class="font-weight-bold d-flex flex-row activity-description justify-content-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>place</mat-icon>2A
                            </div>
                            <div class="d-flex align-items-center">
                                <mat-icon>person</mat-icon>2 {{'people' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="text-center cart-summary-date">12/12/2021 - 12/4/2021</div>
                    <div class="p-0">
                        <div class="sessiontotal d-flex justify-content-between py-3">
                            <div>{{'sessionCharges' | translate}} X 2</div>
                            <div>$10.00</div>
                        </div>
                        <div class="py-3 d-flex justify-content-between">
                            <div>{{'total' | translate}}</div>
                            <div>$10.00</div>
                        </div>
                    </div>
                    <div class="mt-5 d-flex justify-content-between activity-description-bold">
                        <div class="d-flex align-items-center cart-buttons">
                            <mat-icon>edit</mat-icon>
                            <div>{{'edit' | translate}}</div>
                        </div>
                        <div class="d-flex align-items-center cart-buttons" (click)="getPopup()">
                            <mat-icon>delete</mat-icon>
                            <div>{{'remove' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 p-3">
            <div class="cartsummary d-flex flex-column">
                <div class="stanleyimg">
                    <img src="https://www.stanleyhotel.com/uploads/9/8/6/9/98696462/stanley-style-043_5_orig.jpg" />
                </div>
                <div class="card-body activity-description-bold">
                    <div class="card-text text-center p-4 ms-5 me-5">
                        <div class="activityname activity-description-bolder">Historic Day Tour</div>
                        <div class="font-weight-bold d-flex flex-row activity-description justify-content-center">
                            <div class="d-flex align-items-center">
                                <mat-icon>place</mat-icon>2A
                            </div>
                            <div class="d-flex align-items-center">
                                <mat-icon>person</mat-icon>2 {{'people' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="text-center cart-summary-date">12/12/2021 - 12/4/2021</div>
                    <div class="p-0">
                        <div class="sessiontotal d-flex justify-content-between py-3">
                            <div>{{'sessionCharges' | translate}} X 2</div>
                            <div>$10.00</div>
                        </div>
                        <div class="py-3 d-flex justify-content-between">
                            <div>{{'total' | translate}}</div>
                            <div>$10.00</div>
                        </div>
                    </div>
                    <div class="mt-5 d-flex justify-content-between activity-description-bold">
                        <div class="d-flex align-items-center cart-buttons">
                            <mat-icon>edit</mat-icon>
                            <div>{{'edit' | translate}}</div>
                        </div>
                        <div class="d-flex align-items-center cart-buttons" (click)="getPopup()">
                            <mat-icon>delete</mat-icon>
                            <div>{{'remove' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="d-flex flex-wrap justify-content-center">
            <div class="m-3 m-sm-5 activity-buttons activity-confirm-buttons text-center"
                [routerLink]="['/v2/activities/order-summary']">
                CLICK TO PAY
            </div>
            <div class="m-3 m-sm-5 activity-buttons activity-confirm-buttons activity-big-button text-center"
                [routerLink]="['/v2/activities/list']">
                CONTINUE SHOPPING
            </div>
            <div class="m-3 m-sm-5 activity-buttons activity-confirm-buttons text-center" (click)="getPopup()">
                CLEAR CART
            </div>
        </div>
    </div> -->
    <div class="row mx-0 my-3 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
        <div class="col-lg-4 col-md-5 col-sm-12 col-12">
            <div class="activity-buttons m-3 p-3 text-center" [routerLink]="['/v2/activities/order-summary']">{{'clicKToPay' | translate}}</div>
        </div>
        <div class="col-lg-4 col-md-5 col-sm-12 col-12">
            <div class="activity-buttons m-3 p-3 text-center" [routerLink]="['/v2/activities/list']">{{'continueShopping' | translate}}</div>
        </div>
        <div class="col-lg-4 col-md-5 col-sm-12 col-12">
            <div class="activity-buttons m-3 p-3 text-center" (click)="getPopup()">{{'clearCart' | translate}}</div>
        </div>
    </div>
</div>
<ng-template #deleteConfirmationDialog>
    <div class="deletedialog">
        <button type="button" class="close d-flex flex-row-reverse" data-dismiss="alert" aria-label="Close"
            (click)="onNoClick()">
            <span aria-hidden="true">&times;</span>
        </button>
        <div class="pt-5 text-center">{{'removeConfirmationDialog' | translate}}</div>
        <div class="container d-flex justify-content-end">
            <div class="row pt-5">
                <div class="px-1" (click)="onNoClick()"><button mat-flat-button>{{'cancel' | translate}}</button></div>
                <div class="px-1 activity-buttons" (click)="onNoClick()"><button mat-button>{{'confirm' | translate}}</button></div> 
            </div>
        </div>
    </div>
</ng-template>